import { useSelector } from 'hooks/utils';
import { selectFormsBySetName } from 'store/data/forms';

export function useFormsBySetName() {
	return useSelector(state => selectFormsBySetName(state.data.forms));
}
